import {history} from '~/CreateFabricInvitation/history';

export const updateEventIdInPathname = (eventId) => {
  const components = history.location.pathname.split('/');
  components[1] = eventId;
  if (components[2] === 'create') components[2] = 'customize';
  history.replace(
    {
      pathname: components.join('/'),
      hash: history.location.hash,
      search: history.location.search,
    },
    {}
  );
};
